import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AsianPaintsComponent } from './asian-paints.component';

const routes: Routes = [
  {
    path: '',
    component: AsianPaintsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AsianPaintsRoutingModule {}
